import { ObjectLocalStorageValue } from '@/common/local-storage/ObjectLocalStorageValue'
import { localStorageKeys } from '@/core/configs/local-storage-keys'
import type { IAppLifecycleService } from '@/core/lifecycle/AppLifecycleService'

export class CollectionTreeExpandedService {
  private collapsedIds = new Set<string>()
  private readonly storage = new ObjectLocalStorageValue<string[]>(
    localStorageKeys.CollapsedFolderIds,
    [],
  )

  constructor(lifecycleService: IAppLifecycleService) {
    lifecycleService.onAfterFirstRender$.subscribe(() => {
      this.collapsedIds = new Set(this.storage.read() ?? [])
    })
  }

  public isExpanded(id: string): boolean {
    return !this.collapsedIds.has(id)
  }

  public setExpanded(id: string, expanded: boolean): void {
    if (expanded) {
      this.collapsedIds.delete(id)
    } else {
      this.collapsedIds.add(id)
    }
    this.storage.value = [...this.collapsedIds]
  }
}
